// TODO: research the cost benefits of making this a wrapper component that can accept children for pass and children for fail.
// pitfalls of wrapper components and if there is better ways to do DI for our permission checking in the UI.
// TODO: implement memoization to this so it doesn't have to be wrapped in a memo elsewhere

const hasPermission = (permissionsToCheck, userPermissions = []) => {
    const singleValueCheck = (value) => userPermissions?.indexOf(value) > -1;
    if(typeof permissionsToCheck == 'string') return singleValueCheck(permissionsToCheck);
    return Object.values(permissionsToCheck).every(singleValueCheck);
};

export default hasPermission